export default "__VITE_ASSET__CAoJplH0__"